import { Component, OnInit } from '@angular/core';
import {
  FormBuilder,
  FormGroup,
  ReactiveFormsModule,
  Validators,
} from '@angular/forms';
import { Router } from '@angular/router';
import { AuthHeaderComponent } from '../../global/auth-header/auth-header.component';
import { FormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { MatSelectModule } from '@angular/material/select';
import { AuthenticationService } from '@/app/services/auth/authentication.service';
import { NgToastService } from 'ng-angular-popup';
import { environment } from '@/app/environments/environment';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatFormFieldModule } from '@angular/material/form-field';
import { CountryComponent } from "../../global/inputs/country/country.component";

// import { ReCaptchaV3Service, RecaptchaV3Module } from 'ng-recaptcha';

@Component({
  selector: 'app-register',
  standalone: true,
  imports: [
    ReactiveFormsModule,
    MatSelectModule,
    AuthHeaderComponent,
    FormsModule,
    CommonModule,
    MatFormFieldModule,
    MatInputModule,
    MatIconModule,
    CountryComponent
],
  templateUrl: './register.component.html',
  styleUrls: ['./register.component.css'],
})
export class RegisterComponent implements OnInit {
  viewPassword: boolean = false;
  countryFromMap = 'United States';
  countryId: number = 185;
  form: FormGroup;
  isCheck = false;
  // recaptchaToken: string = '';
  recaptchaToken: string = '';

  constructor(
    private fb: FormBuilder,
    private router: Router,
    private authService: AuthenticationService,
    private toast: NgToastService // private recaptchaV3Service: ReCaptchaV3Service
  ) {
    this.form = this.fb.group({
      org_name: ['', Validators.required],
      org_designation: ['', Validators.required],
      org_type: ['', Validators.required],
      org_email: ['', Validators.required],
      phonenumber: ['', [Validators.required]],
      password: ['', [Validators.required, Validators.minLength(8)]],
      confirmPassword: ['', [Validators.required, Validators.minLength(8)]],
      logoPreview: [''],
      logoFile: [''],
    });
  }

  ngOnInit(): void {
    // Wait for the `grecaptcha` object to load
    this.loadRecaptcha();
  }

  loadRecaptcha() {
    const checkRecaptcha = () => {
      if (window['grecaptcha']) {
        // Render the reCAPTCHA widget
        this.renderRecaptcha();
      } else {
        // Retry after 500ms if `grecaptcha` is not yet loaded
        setTimeout(checkRecaptcha, 500);
      }
    };

    checkRecaptcha();
  }
  updateCountry(country: any) {
    this.countryFromMap = country.name;
    this.countryId = country.id;
  }

  renderRecaptcha() {
    const grecaptcha = window['grecaptcha'];
    grecaptcha.ready(() => {
      this.executeRecaptcha(); // 'this' is automatically bound to the class instance in arrow functions
    });
  }

  executeRecaptcha() {
    const grecaptcha = window['grecaptcha'];
    grecaptcha
      .execute(environment.google_recaptcha_site_key, { action: 'submit' })
      .then((token: string) => {
        // Arrow function ensures 'this' refers to the class instance
        this.recaptchaToken = token;
      })
      .catch((error: any) => {
        console.error('Error executing reCAPTCHA:', error);
      });
  }

  // Reference to the file input
  uploadLogo() {
    const fileInput = document.querySelector(
      'input[type="file"]'
    ) as HTMLInputElement;
    fileInput.click();
  }

  // Handle file selection
  onFileSelected(event: any) {
    const file = event.target.files[0];

    if (file) {
      if (file.type.startsWith('image/') && file.size <= 2000000) {
        this.form.patchValue({
          logoFile: file,
        });

        const reader = new FileReader();
        reader.onload = () => {
          this.form.patchValue({
            logoPreview: reader.result,
          });
        };
        reader.readAsDataURL(file);
      } else {
        alert('Invalid file. Only images under 2MB are allowed.');
      }
    }
  }

  async prepareDataToSubmit() {
    const dataToSubmit = new FormData();
    dataToSubmit.append('token', this.recaptchaToken);
    dataToSubmit.append('name', this.form.get('org_name')?.value);
    dataToSubmit.append('title', this.form.get('org_designation')?.value);
    dataToSubmit.append('organization_type', this.form.get('org_type')?.value);
    dataToSubmit.append('email', this.form.get('org_email')?.value);
    dataToSubmit.append('phone', this.form.get('phonenumber')?.value);
    dataToSubmit.append('password', this.form.get('password')?.value);
    dataToSubmit.append('country_id', `${this.countryId}`);

    dataToSubmit.append(
      'password_confirmation',
      this.form.get('confirmPassword')?.value
    );
    dataToSubmit.append('logo', this.form.get('logoFile')?.value as File);
    return dataToSubmit;
  }

  async onSubmit() {
    // this.recaptchaV3Service.execute('register').subscribe({
    //   next: async (token: string) => {
    //     this.recaptchaToken = token;

    //   },
    //   error: (err) => {
    //     console.error('reCAPTCHA execution failed:', err);
    //     this.toast.danger('Unprocessable action. Please try again.', 'DANGER', 4000);
    //   },
    // });

    if (this.form.valid && this.recaptchaToken) {
      try {
        const dataToSubmit = await this.prepareDataToSubmit();

        this.authService.registerOrganization(dataToSubmit).subscribe({
          next: (response: any) => {
            console.log('Register response:', response);
            if (!response.status) {
              this.toast.danger(
                response.errors?.message || 'Registration failed',
                'DANGER',
                4000
              );
              return;
            }
            localStorage.setItem('org_info', JSON.stringify(response.user));
            this.toast.success(
              'Please verify OTP on the provided email address!',
              'SUCCESS',
              4000
            );
            this.router.navigate(['/verification']);
          },
          error: (error: any) => {
            console.error('Registration failed:', error);
            this.toast.danger(
              error?.error?.message || 'Unexpected error occurred',
              'DANGER',
              4000
            );
            this.executeRecaptcha();
          },
        });
      } catch (error) {
        console.error('Data preparation failed:', error);
        this.toast.danger(
          'Failed to prepare data for submission',
          'DANGER',
          4000
        );
        this.executeRecaptcha();
      }
    } else {
      this.form.markAllAsTouched();
      console.log('Form is invalid');
      this.toast.danger('Please fill in all required fields', 'DANGER', 4000);
      this.executeRecaptcha();
    }
  }

  setIsCheck(value: boolean) {
    this.isCheck = value;
  }
  register() {
    this.router.navigate(['/register']);
  }
  login() {
    this.router.navigate(['/login']);
  }
  navigateToVerification() {
    this.router.navigate(['/verification']);
  }
  navigateTo() {
    this.router.navigate(['/login']);
  }
  organizationTypes = [
    { value: 'consultancy_services', label: 'Consultancy Services' },
    { value: 'construction_works', label: 'Construction Works' },
  ];
}
